// Barrel del client API admin.
// I consumer importano da '@admin/lib/api' (o '../lib/api') anziché dai sotto-file.

import * as auth from './auth';
import * as flows from './flows';
import * as patients from './patients';
import * as encounters from './encounters';
import * as usage from './usage';
import * as settings from './settings';
import * as integrations from './integrations';

export { ApiClientError } from './_request';
export type { PatientDetail, PatientList } from './patients';
export type { EncounterListItem, EncounterDetail, EncounterPdfMode } from './encounters';
export type { UsageMonthly, UsageDashboardResponse } from './usage';
export type {
  SettingsResponse,
  AdminUserRow,
  TotpSetupInitResponse,
  TotpStatus,
  AuditLogRow,
  AuditLogListResponse,
} from './settings';
export type { ApiKeyCreatedResponse, KioskSettings } from './integrations';
export { downloadEncounterPdfUrl } from './encounters';
export { bulkExportFullUrl } from './integrations';
export const api = {
  ...auth,
  ...flows,
  ...patients,
  ...encounters,
  ...usage,
  ...settings,
  ...integrations,
};
